module.exports = __webpack_public_path__ + "6fdd707cc9d3278930d1618a8944f44d.svg";